import { render, staticRenderFns } from "./AssetList.vue?vue&type=template&id=fc455f4a&scoped=true"
import script from "./AssetList.vue?vue&type=script&lang=ts"
export * from "./AssetList.vue?vue&type=script&lang=ts"
import style0 from "./AssetList.vue?vue&type=style&index=0&id=fc455f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc455f4a",
  null
  
)

export default component.exports